/**
 * L2-R5: moved verbatim from @shared/utils/classes/rent-validators.
 * That host path is now a re-export shim of this file.
 */
import { digger } from '@cbre/digger';
import { DASH } from './strings.constants';

export const isNaOrEmptyValidator = rent => rent === DASH || rent == null;

/**
 * @deprecated
 * use simpleValueValidation instead
 * OR move to lease-compare.config.ts since is the only place it's beind used
 *
 */
export const notApplicableValidator = (value, uom, data) => {
  return isNaOrEmptyValidator(digger(data, value)) || isNaOrEmptyValidator(digger(data, uom));
};
